import api from '../../services/api'
import {
  USER_TABLE,
  USER_IS_FETCHING,
  USER_IS_UPDATING,
  USER_PASSWORD_IS_UPDATING,
  USER_SUCCESS,
  USER_LIST_IS_FETCHING,
  USER_GET_ALL,
  USER_DELETE_ID,
  USER_DELETE_ARRAY,
  USER_CREATE,
  USER_UPDATE_ID,

  USER_STATUS_UPDATING
} from '../types'

import { message } from 'antd'

export function getUser () {
  return (dispatch) => {
    dispatch(isFetching(USER_IS_FETCHING, true))

    return api.user.getUser()
      .then(response => {
        if (response && !response.data.error) {
          dispatch({
            type: USER_SUCCESS,
            payload: response.data.result
          })
        }
      })
      .then(() => {
        dispatch(isFetching(USER_IS_FETCHING, false))
      })
      .catch((error) => {
        console.log(error.response)
        message.error('Server error')
      })
  }
}

export function updateUser (firstName, lastName, email) {
  return (dispatch) => {
    dispatch(isFetching(USER_IS_UPDATING, true))

    api.user.updateUser(firstName, lastName, email).then(response => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_SUCCESS,
          payload: response.data.result
        })
      }
    }).then(() => {
      dispatch(isFetching(USER_IS_UPDATING, false))
      message.success('Profile successfully updated')
    })
  }
}

export function updateUserPassword (oldPassword, newPassword) {
  return (dispatch) => {
    dispatch(isFetching(USER_PASSWORD_IS_UPDATING, true))

    api.user.updateUserPassword(oldPassword, newPassword).then((response) => {
      if (response && response.data.error) {
        message.error(response.data.error.message)
      } else {
        dispatch({
          type: USER_SUCCESS,
          payload: response.data.result
        })
        message.success('Password successfully changed')
      }
      dispatch(isFetching(USER_PASSWORD_IS_UPDATING, false))
    })
  }
}

export function getUsers () {
  return (dispatch) => {
    dispatch(isFetching(USER_LIST_IS_FETCHING, true))

    return api.user.getUsers()
      .then((response) => {
        if (response && !response.data.error) {
          dispatch({
            type: USER_GET_ALL,
            payload: response.data.result
          })
        }
      })
      .then(() => {
        dispatch(isFetching(USER_LIST_IS_FETCHING, false))
      })
  }
}

export function updateTable (payload) {
  return {
    type: USER_TABLE,
    payload
  }
}

export function deleteUsersByArray (data) {
  return (dispatch) => {
    return api.user.deleteUsersByArray(data).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_DELETE_ARRAY,
          payload: response.data.result
        })
      }
    })
  }
}

export function deleteUserById (data) {
  return (dispatch) => {
    return api.user.deleteUserById(data).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_DELETE_ID,
          payload: response.data.result
        })
      }
    })
  }
}

export function createUser (data) {
  return (dispatch) => {
    return api.user.createUser(data).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_CREATE,
          payload: response.data.result
        })
      }
      return response
    })
  }
}

export function updateUserById (id, params) {
  return (dispatch) => {
    dispatch({
      type: USER_STATUS_UPDATING,
      payload: true
    })
    return api.user.updateUserById(id, params)
    .then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_UPDATE_ID,
          payload: response.data.result
        })
        dispatch({
          type: USER_STATUS_UPDATING,
          payload: false
        })
      }
      return response
    }).catch(() => {
      dispatch({
        type: USER_STATUS_UPDATING,
        payload: false
      })
    })
  }
}

export function activateUser (id, params) {
  return (dispatch) => {
    dispatch({
      type: USER_STATUS_UPDATING,
      payload: true
    })

    return api.user.updateUserById(id, params).then((response) => {
      if (response && !response.data.error) {
        dispatch({
          type: USER_UPDATE_ID,
          payload: response.data.result
        })

        dispatch({
          type: USER_STATUS_UPDATING,
          payload: false
        })
        return response
      }
    }).catch(() => {
      dispatch({
        type: USER_STATUS_UPDATING,
        payload: false
      })
    })
  }
}

export function resetPassword (email, organizationId) {
  return (dispatch) => {
    dispatch(isFetching(USER_IS_FETCHING, true))

    return api.user.resetPassword(email, organizationId).then((response) => {
      dispatch(isFetching(USER_IS_FETCHING, false))
      return response
    })
  }
}

function isFetching (type, payload) {
  return {
    type,
    payload
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/user.js